(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxGoProperties() {
    return {
      restrict: 'EA',
      scope: {
        goProfile: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/onDeviceConfigProperties/goProperties/goProperties.template.html',
      link: function(scope) {

        scope.goConfig = {
          signInMethod: 'automatically'
        };

        (function() {
          // init
        })();

      }
    };
  }

  pxGoProperties.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxGoProperties', pxGoProperties);

})();
